/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import ls from 'local-storage';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { Container } from '@material-ui/core';
import 'typeface-roboto';
import NumberFormat from 'react-number-format';
import Divider from '@material-ui/core/Divider';
import LinearProgress from '@material-ui/core/LinearProgress';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Badge from '@material-ui/core/Badge';
import OlsBottomNav from '../../container/OlsBottomNav/OlsBottomNav';
import OlsProductImageSlider from '../../container/OlsProductImageSlider/OlsProductImageSlider';
import OlsItemEdit from '../../container/OlsItemEdit/OlsItemEdit';
import Toast from '../../component/Toast/Toast';

let isMounted = false;

const useStyles = (theme) => ({
  appBarWrapper: {
    backgroundColor: 'white',
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 'auto',
    paddingRight: '0px !important',
  },
  appBarTitle: {
    position: 'relative',
    display: 'block',
    fontWeight: 'bold',
    marginLeft: 0,
    width: '100%',
  },
  appToolbar: {
    height: 62,
    minHeight: 62,
    maxHeight: 62,
  },
  content: {
    marginTop: 5,
    marginBottom: 60,
    padding: 4,
    display: 'block',
    minHeight: 1000,
  },
  titleStyle: {
    textAlign: 'center',
  },
  textCenter: {
    textAlign: 'center',
  },
  discount: {
    color: 'red',
    fontWeight: 'bold',
  },
  buttonStyle: {
    margin: '10px 0px',
    borderRadius: 0,
    padding: 15,
    fontWeight: 'bold',
  },
});

// const orderInfoSample = {
//   order_uxid: '1234',
//   order_version: 'V!',
//   order_account_uxid: '4324213',
//   order_from_type: '2432143',
//   order_from_uxid: '2432143214',
//   order_number: '243245325',
//   order_name: 'wianto',
//   order_courier_code: 'jnt',
//   order_courier_name: 'JNE',
//   order_courier_service: 'Reguler',
//   order_courier_description: ' ',
//   order_store_name: 'Laris Manis',
//   order_store_province_id: '1',
//   order_store_province_name: '2',
//   order_store_city_id: '3',
//   order_store_city_name: '4',
//   order_store_city_type: '5',
//   order_store_subdistrict_id: '6',
//   order_store_subdistrict_name: '7',
//   order_shipping_realname: 'Wianto',
//   order_shipping_code: 'JT1726296122',
//   order_shipping_phone: '0812345678',
//   order_shipping_company: 'Company',
//   order_shipping_email: 'wianto@gmail.com',
//   order_shipping_address1: 'Desa Gentawangi RT.01/05',
//   order_shipping_address2: 'Jatilawang',
//   order_shipping_address3: 'Banyumas',
//   order_shipping_address4: '53174',
//   order_shipping_address5: ' ',
//   order_shipping_location_id: '1',
//   order_shipping_province_id: '2',
//   order_shipping_province_name: '3',
//   order_shipping_city_id: '4',
//   order_shipping_city_name: '5',
//   order_shipping_city_type: '6',
//   order_shipping_subdistrict_id: '7',
//   order_shipping_subdistrict_name: '8',
//   order_shipping_note: 'OK',
//   order_shipping_detail: 'OK',
//   order_shipping_cost: 2000,
//   order_weight: 1000,
//   order_value: 4750,
//   order_tax_percent: 10,
//   order_tax_value: 475,
//   order_discount_type: 'PERCENTAGE',
//   order_discount_value: 0,
//   order_discount_price: 0,
//   order_total: 7700,
//   order_profit: 0,
//   order_uxcode: 123,
//   order_cash_pay: 7823,
//   order_cash_change: 123,
//   order_note: '',
//   order_step: 'CREATE',
//   order_payment_status: 'WAIT',
//   order_expired_status: '0',
//   order_mutasi_uxid: '214231',
//   order_status: 'WAIT',
//   order_timestamp: 1588776330,
//   order_date: '2020/05/05',
// };
// const itemListSample = [
//   {
//     item_uxid: '1234',
//     item_account_uxid: '',
//     item_from_type: '',
//     item_from_uxid: '',
//     item_order_uxid: '',
//     item_order_version: '',
//     item_parent_uxid: '',
//     item_group: 'TRS',
//     item_tree: 'TRS',
//     item_product_type: 'GOODS',
//     item_product_uxid: 'PRD6911464919984',
//     item_product_name: 'Mie Sedap',
//     item_product_code: '977464565433',
//     item_product_unit: 'pcs',
//     item_product_weight: 20,
//     item_product_base_price: 2000,
//     item_product_sale_price: 2500,
//     item_product_discount_type: 'PERCENTAGE',
//     item_product_discount_value: 5,
//     item_amount: 2,
//     item_weight: 40,
//     item_base_value: 4000,
//     item_sale_value: 5000,
//     item_discount_type: 'PERCENTAGE',
//     item_discount_value: 5,
//     item_discount_price_unit: 175,
//     item_discount_price_total: 250,
//     item_base_total: 4000,
//     item_sale_total: 4750,
//     item_profit: 750,
//     item_total: 4750,
//     item_note: 'pedes',
//     item_status: 'CHECKOUT',
//     item_timestamp: 0,
//   },
// ];

const { pathname } = window.location;
const arrPath = pathname.split('/');
const username = (arrPath && arrPath.length >= 3) ? arrPath[3] : '';

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      order_info: {},
      item_list: [],
      product_info: {},
      image_album: [],
      loading: false,
      itemEdit: false,
      itemEditData: {},
      toastOpen: false,
      toastMessage: '',
      toastSeverity: 'info',
    };
  }

  componentDidMount() {
    isMounted = true;
    if (isMounted) {
      if (this.props.match.params) {
        const { uxid } = this.props.match.params;
        const productViewTemp = `${username}_product_${uxid}`;
        const productInfo = ls.get(productViewTemp);
        if (_.isObject(productInfo)) {
          if (_.isString(productInfo.product_image_url_filename)) {
            const productDefaultImage = productInfo.product_image_url_filename;
            this.setState({ image_album: [productDefaultImage] });
          }
        }
        this.setState({
          product_info: productInfo || {},
        });
        this.setState({ loading: true });
        axios.post(`https://eqiozmart.com/olsapi/product/product_info/${username}/${uxid}/`).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isObject(response.data.product_info)) {
              const productInfoResp = response.data.product_info;
              if (_.isString(productInfoResp.product_uxid)) {
                this.setState({
                  product_info: productInfoResp,
                });
                const productViewTempResp = `${username}_product_${productInfoResp.product_uxid}`;
                ls.set(productViewTempResp, productInfoResp);
                if (_.isArray(response.data.photos)) {
                  this.setState({ image_album: response.data.photos });
                }
              }
            }
          }
        });

        // this.setState({ order_info: orderInfoSample });
        // this.setState({ item_list: itemListSample });

        const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
        const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
        const orderInfo = ls.get(lsShoppingCartOrderInfo);
        if (_.isObject(orderInfo)) {
          if (_.isString(orderInfo.order_uxid)) {
            this.setState({ order_info: orderInfo });
            const itemList = ls.get(lsShoppingCartItemList);
            if (_.isArray(itemList)) {
              this.setState({ item_list: itemList });
            }
          }
        }
        this.setState({ loading: true });
        axios.post(`https://eqiozmart.com/olsapi/olshop/order_info/${username}/`).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isObject(response.data.order_info)) {
              const orderInfoResp = response.data.order_info;
              if (_.isString(orderInfoResp.order_uxid)) {
                this.setState({ order_info: orderInfoResp });
                ls.set(lsShoppingCartOrderInfo, orderInfoResp);
              }
            }
            if (_.isArray(response.data.item_list)) {
              const itemListResp = response.data.item_list;
              this.setState({ item_list: itemListResp });
              ls.set(lsShoppingCartItemList, itemListResp);
            }
          }
        });
      }
    }
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    isMounted = false;
  }

  handleGoBack = () => {
    if (this.props.history.length > 0) {
      this.props.history.goBack();
    }
  }

  toastShow = (severity, message) => {
    this.setState({
      toastOpen: true,
      toastMessage: message,
      toastSeverity: severity,
    });
  }

  toastOnClose = () => {
    this.setState({
      toastOpen: false,
    });
  }

  handleItemEditClose = () => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });
    }
  }

  handleItemEditDelete = (fields) => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });

      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('item_uxid', fields.item_uxid);
      formdata.append('item_amount', fields.item_amount);
      formdata.append('item_note', fields.item_note);
      axios.post('https://eqiozmart.com/olsapi/olshop/item_delete/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleItemEditSave = (fields) => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });

      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('item_uxid', fields.item_uxid);
      formdata.append('item_amount', fields.item_amount);
      formdata.append('item_note', fields.item_note);
      axios.post('https://eqiozmart.com/olsapi/olshop/item_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleClickBuy = () => {
    if (isMounted) {
      const usrInfo = ls.get('usr_info');
      if (_.isString(usrInfo.usr_realname)) {
        if (_.isString(this.state.order_info.order_uxid)) { // untuk memastikan object order terload dengan benar
          if (_.isString(this.state.product_info.product_uxid)) { // untuk memastikan object product terload dengan benar
            const item = _.find(this.state.item_list, { item_product_uxid: this.state.product_info.product_uxid });
            if (_.isObject(item)) {
              if (this.state.order_info.order_step === 'CREATE') {
                this.setState({
                  itemEdit: true,
                  itemEditData: item,
                });
              } else {
                this.toastShow('error', 'Tidak dapat beli produk ini');
              }
            } else {
              const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
              const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
              this.setState({ loading: true });
              const formdata = new FormData();
              formdata.append('item_order_uxid', this.state.order_info.order_uxid);
              formdata.append('item_product_uxid', this.state.product_info.product_uxid);
              formdata.append('item_amount', 1);
              formdata.append('item_note', '');
              axios.post('https://eqiozmart.com/olsapi/olshop/item_add/', formdata).then((response) => {
                if (isMounted) {
                  this.setState({ loading: false });
                  if (_.isObject(response.data.order_info)) {
                    const orderInfoResp = response.data.order_info;
                    if (_.isString(orderInfoResp.order_uxid)) {
                      this.setState({ order_info: orderInfoResp });
                      ls.set(lsShoppingCartOrderInfo, orderInfoResp);
                    }
                  }
                  if (_.isArray(response.data.item_list)) {
                    const itemListResp = response.data.item_list;
                    this.setState({ item_list: itemListResp });
                    ls.set(lsShoppingCartItemList, itemListResp);
                  }
                  //= toast start
                  if (_.isString(response.data.status)) {
                    if (response.data.status === 'success') {
                      if (_.isString(response.data.message)) {
                        const { message } = response.data;
                        this.toastShow('success', message);
                      }
                    } else if (_.isString(response.data.message)) {
                      const { message } = response.data;
                      this.toastShow('error', message);
                    }
                  }
                  //= toast end
                  const itemEd = _.find(this.state.item_list, { item_product_uxid: this.state.product_info.product_uxid });
                  if (_.isObject(itemEd)) {
                    if (this.state.order_info.order_step === 'CREATE') {
                      this.setState({
                        itemEdit: true,
                        itemEditData: itemEd,
                      });
                    } else {
                      this.toastShow('error', 'Tidak dapat beli produk ini');
                    }
                  }
                }
              });
            }
          }
        }
      } else {
        this.props.history.push('/login');
      }
    }
  };

  handleShoppingCartOpen = () => {
    if (isMounted) {
      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      ls.set(lsShoppingCartOrderInfo, this.state.order_info);
      ls.set(lsShoppingCartItemList, this.state.item_list);
      this.props.history.push('/shoppingcart');
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <div className={classes.appBarWrapper}>
          <AppBar className={classes.appBar}>
            <Toolbar className={classes.appToolbar}>
              <IconButton edge="start" color="inherit" onClick={this.handleGoBack}>
                <ArrowBackIcon />
              </IconButton>
              <Typography className={classes.appBarTitle} variant="h6" noWrap>
                {this.state.product_info.product_name}
              </Typography>
              <div className={classes.appBarCart}>
                <IconButton color="inherit" onClick={this.handleShoppingCartOpen}>
                  <Badge badgeContent={_.size(this.state.item_list)} color="secondary">
                    <ShoppingCartIcon />
                  </Badge>
                </IconButton>
              </div>
            </Toolbar>
            <div style={{ marginBottom: -5, height: 5 }}>
              <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
            </div>
          </AppBar>
        </div>
        <div className={classes.content}>
          <OlsProductImageSlider album={this.state.image_album} />
          <Container>
            <Typography className={classes.textCenter} variant="h6">
              Harga :
              {' '}
              <NumberFormat value={this.state.product_info.product_sale_price} isNumericString displayType="text" decimalScale={0} thousandSeparator="." decimalSeparator="," />
              {' '}
              /
              {' '}
              {this.state.product_info.product_unit}
            </Typography>
            {this.state.product_info.product_stock_amount > 0 && <Divider />}
            {this.state.product_info.product_stock_amount > 0
              && (
                <Typography className={classes.textCenter} variant="subtitle2">
                  Stok :
                  {' '}
                  {<NumberFormat value={this.state.product_info.product_stock_amount} isNumericString displayType="text" decimalScale={0} thousandSeparator="." decimalSeparator="," />}
                  {' '}
                  {this.state.product_info.product_unit}
                </Typography>
              )}

            {this.state.product_info.product_discount_value > 0 && <Divider />}
            {this.state.product_info.product_discount_value > 0
              && (
                <Typography className={classes.textCenter} variant="subtitle2">
                  Diskon :
                  {' '}
                  <NumberFormat className={classes.discount} value={this.state.product_info.product_discount_value} isNumericString displayType="text" decimalScale={0} thousandSeparator="." decimalSeparator="," />
                  {this.state.product_info.product_discount_type === 'PERCENTAGE' ? ' %' : ''}
                </Typography>
              )}

            <Divider />
            <Button className={classes.buttonStyle} fullWidth variant="contained" color="primary" onClick={this.handleClickBuy}>
              BELI
            </Button>

            {this.state.product_info.product_detail > 0 && <Divider />}
            <Typography className={classes.textCenter} variant="body1">
              {this.state.product_info.product_detail}
            </Typography>
          </Container>

        </div>
        <OlsItemEdit data={this.state.itemEditData} onClose={this.handleItemEditClose} onSave={this.handleItemEditSave} onDelete={this.handleItemEditDelete} open={this.state.itemEdit} />
        <Toast open={this.state.toastOpen} message={this.state.toastMessage} severity={this.state.toastSeverity} onClose={this.toastOnClose} />
        <OlsBottomNav />
      </div>
    );
  }
}

Product.defaultProps = {
  data: {
    product_uxid: '',
    product_name: '',
    product_code: '',
    product_detail: '',
    product_unit: '',
    product_sale_price: 0,
    product_discount_type: '',
    product_discount_value: 0,
    product_stock_amount: 0,
    product_image_url_filename: '',
  },
};

export default withStyles(useStyles)(Product);
